import { Injectable } from '@angular/core';

/**
 * Tracks how many Michelin dropdown panels (opened via {@link MichelinDropdownAccessibilityDirective})
 * are currently open across the app. Consumers such as modal Escape-to-close handlers use this to
 * avoid closing themselves when the Escape key press was meant to close a nested dropdown panel instead.
 */
@Injectable({ providedIn: 'root' })
export class MichelinDropdownOverlayStateService {
  private openCount = 0;

  get hasOpenDropdown(): boolean {
    return this.openCount > 0;
  }

  markOpened(): void {
    this.openCount++;
  }

  markClosed(): void {
    this.openCount = Math.max(0, this.openCount - 1);
  }
}
